/* eslint-disable @repo/internal/react/require-jsdoc */
import React, { type ReactNode } from 'react';

import { Banner, PageContentContainer } from '@af/design-system-docs-ui';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { ContextualAnalyticsData, FireScreenAnalytics, SCREEN } from '@atlassian/analytics-bridge';

import MetaTags from '../__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/components/meta-tags';
import { normalizeSourceName } from '../utils/analytics';
import titleify from '../utils/titleify';

type OverviewPageProps = {
	title: string;
	description: string;
	image?: {
		light: string;
		dark: string;
	};
	categorySlug: string;
	entries: Array<any>;
	tileColor?: string;
	defaultIcon?: string;
	guidelineCategory?: string;
	children: ReactNode;
};

const pageWidthStyles = xcss({
	maxWidth: '980px',
});

const OverviewPage = ({
	title,
	description,
	image,
	categorySlug,
	entries,
	children,
}: OverviewPageProps) => {
	return (
		<ContextualAnalyticsData
			sourceType={SCREEN}
			sourceName="index"
			attributes={{
				name: `${normalizeSourceName(title)}Home`,
				entriesCount: entries.length,
			}}
		>
			<MetaTags title={title} description={description} categorySlug={titleify(categorySlug)} />
			<FireScreenAnalytics key={title} />
			<Banner title={title} description={description} image={image} />
			<Flex justifyContent="center">
				<PageContentContainer>
					<Box paddingBlock="space.800" xcss={pageWidthStyles}>
						{children}
					</Box>
				</PageContentContainer>
			</Flex>
		</ContextualAnalyticsData>
	);
};

export default OverviewPage;
